import { jsx as _jsx } from "react/jsx-runtime";
import { FileStatusButton, FileStatusIconProgressing, FileStatusSubtitle, FileStatusTitle } from "@air/feature-file-status/ui";
import { Close } from "@air/next-icons";
import { formatDistance } from "__barrel_optimize__?names=formatDistance!=!date-fns";
import isNumber from "lodash/isNumber";
import pluralize from "pluralize";
import { memo } from "react";
import { PaneItemTW } from "~/components/FileStatusTrackingPane/PaneItemTW";
export const ZippingTaskInProgressPanelItem = /*#__PURE__*/ memo((param)=>{
    let { onCancel, metadata: { clipIds = [], boardIds = [], secondsRemaining } } = param;
    return /*#__PURE__*/ _jsx(PaneItemTW, {
        avatar: /*#__PURE__*/ _jsx(FileStatusIconProgressing, {}),
        title: /*#__PURE__*/ _jsx(FileStatusTitle, {
            "data-testid": "ZIPPING_PANEL_IN_PROGRESS_TITLE",
            children: "Zipping ".concat(pluralize("item", clipIds.length + boardIds.length, true))
        }),
        subtitle: /*#__PURE__*/ _jsx(FileStatusSubtitle, {
            className: "truncate",
            children: isNumber(secondsRemaining) ? "".concat(formatDistance(new Date(Date.now() + secondsRemaining * 1000), new Date(), {
                includeSeconds: true
            }), " left") : "Your download will begin shortly."
        }),
        buttons: /*#__PURE__*/ _jsx(FileStatusButton, {
            label: "Cancel",
            onClick: ()=>onCancel(),
            children: /*#__PURE__*/ _jsx(Close, {
                className: "size-4"
            })
        })
    });
});
ZippingTaskInProgressPanelItem.displayName = "ZippingInProgressPanelItem";
